import { useEffect, useState } from 'react';
import { restGetUserReportAssignments } from '@/app/services/reports';
import { UserReportsFormValues } from '../../ReportsTab/types';

export const useUserReportAssignments = (
    userId: number | undefined,
    hasPermission: boolean
) => {
    const [assignments, setAssignments] = useState<UserReportsFormValues>({});

    useEffect(() => {
        if (hasPermission) {
            const load = async () => {
                if (!userId) {
                    setAssignments({});
                    return;
                }
                try {
                    const res = await restGetUserReportAssignments(userId);
                    const ass = res.reduce<UserReportsFormValues>((acc, a) => {
                        acc[a.assignmentId] = {
                            name: a.name,
                            typeId: a.typeId,
                            templateId: a.templateId,
                        };
                        return acc;
                    }, {});
                    setAssignments(ass);
                } catch (e) {
                    setAssignments({});
                }
            };
            load();
        }
    }, [hasPermission, userId]);

    return assignments;
};
